import { APIService } from './../authentication/APIService';

export default {
    getOrders(
        page = 1,
        pageSize = 12
    ) {
        // Generate url
        let url = 'api/account/orders?';

        // Mandatory parameters
        url += 'page=' + page + '&';
        url += 'per_page=' + pageSize;

        return APIService.get(url);

    },

    getOrder(orderId) {
        return APIService.get("api/account/orders/" + orderId);
    },
}